import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'reason',
      type: 'autocomplete',
      label: '原因',
      placeholder: '请输入原因题',
      otherOptions: {
        clearable: true
      }
    },
    {
      field: 'changePoint',
      type: 'input',
      label: '变动金币数',
      placeholder: '请输入金币数',
      rules: [{ required: true, message: '金币数是必传的', trigger: 'blur' }]
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
